var app = angular.module('leonardo');

var TagsController = function ($scope, $controller, $state, $q, ngDialog, DeficiencyTagService, FilterService,
                               NotificationService, AuthDataService) {
  $scope.order = 'resource_id';
  $scope.tagsList = [];
  $scope.authDataService = AuthDataService;
  $scope.system = $state.current.system;

  $scope.showTagEditDialog = function (tagData) {
    ngDialog.openConfirm({
      controller: 'SystemTagAddDialog',
      templateUrl: 'views/templates/dialog/dynamic-form/system-tag-add.html',
      data: {tag: tagData, mode: 'edit'}
    })
  };

  $scope.getEntitiesPromise = function (options) {
    const defer = $q.defer();
    $scope.loading = true;
    if ($scope.system) {
      if ($scope.filterService.hasFilter('is_published')) {
        options['is_published'] = $scope.filterService.getFilter('is_published');
      }
    }
    else {
      if (FilterService.hasFilter('enabled_for_dynamic_forms')) {
        options['enabled_for_dynamic_forms'] = FilterService.getFilter('enabled_for_dynamic_forms');
      }
      if (FilterService.hasFilter('enabled_for_reports')) {
        options['enabled_for_reports'] = FilterService.getFilter('enabled_for_reports');
      }
      if ($scope.filterService.hasFilter('is_search_by_displayname')) {
        options['display_name'] = $scope.filterService.getFilter('is_search_by_displayname');
      }
    }
    if ($scope.filterService.hasFilter('is_search_by_attribute')) {
      options['tag_name'] = $scope.filterService.getFilter('is_search_by_attribute');
    }
    DeficiencyTagService.getTagsList(options).then(function (data) {
      $scope.tagsList = data?.results || data;
      $scope.loading = false;
      defer.resolve(data);
    }, function (error) {
      $scope.loading = false;
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.DynamicFormToggle = function (SwitchToOFF, tag) {
    if (SwitchToOFF) {
      ngDialog
        .openConfirm({
          template: 'views/templates/dialog/dynamic-form/toggle-off-warning.html',
          controller: 'DynamicFormToggleWarningDialog',
        })
        .then(function (isTurnOff) {
          if (isTurnOff) {
            DeficiencyTagService.updateTag({
              "allow_use_in_dynamic_forms": false,
              "tag_name": tag.tag_name
            }, tag.id).then(function () {
              tag.allow_use_in_dynamic_forms = !tag.allow_use_in_dynamic_forms;
              NotificationService.notify('success', 'Dynamic form toggle has been turned OFF successfully');
            });
          }
        });
    } else {
      DeficiencyTagService.updateTag({
        "allow_use_in_dynamic_forms": true,
        "tag_name": tag.tag_name
      }, tag.id).then(function () {
        tag.allow_use_in_dynamic_forms = !tag.allow_use_in_dynamic_forms;
        NotificationService.notify('success', 'Dynamic form toggle has been turned ON successfully');
      });
    }
  }

  $scope.ReportingToggle = function (tag) {
    DeficiencyTagService.updateTag({
      "allow_use_in_reports": !tag.allow_use_in_reports,
      "tag_name": tag.tag_name
    }, tag.id).then(function () {
      tag.allow_use_in_reports = !tag.allow_use_in_reports;
      if (tag.allow_use_in_reports)
        NotificationService.notify('success', 'Reporting toggle has been turned ON successfully');
      else
        NotificationService.notify('success', 'Reporting toggle has been turned OFF successfully');
    });
  }

  $scope.editPublish = function (tagData) {
    tagData.is_active = !tagData.is_active;
    DeficiencyTagService.updateTag(tagData, tagData.id).then(function () {
      if(tagData.is_active){
        NotificationService.notify('success', 'Publish toggle has been turned ON successfully');
      }
      else{
        NotificationService.notify('success', 'Publish toggle has been turned OFF successfully');
      }
    });
};

  $scope.$on('deficiency-tags:updated', function () {
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', {$scope: $scope});
  $scope.loadPage(1);

};
app.controller('TagsController', ['$scope', '$controller', '$state', '$q', 'ngDialog', 'DeficiencyTagService',
  'FilterService', 'NotificationService', 'AuthDataService', TagsController]);